document.addEventListener("latte:init", init);

function init () {
	//PAGE LOAD
	var docId = $('.product-config').attr('config-docId'); // get CMS docId
	var preSelect = ($('.product-config').attr('config-preSelected') === 'true') ? true : false;
	var s = sessionStorage.getItem(docId) ? JSON.parse(sessionStorage.getItem(docId)) : undefined; // get data from previous visit
	var w = (s && typeof s === 'object') ? s : {   // assign stored data, else create an empty object
		'addToCartList': [],
		'groupList': [],
		'schedulerURL': $('.js-config-tile').children().attr('config-schedule') ? 'true' : '', //check scheduler exist button null state match active state
		'selectedTiles': [],
		'productId': '',
		'total': undefined,
		'zipCode': ($('.js-config-tile').children().attr('config-requiredZipCode') === 'true') ? ['true'] : [], //check zip field button null state match active state
	};
	if (preSelect && !s) {
		_clickHandler($('.pre-selected-tile'), true);
	}
	_updateView(); //update view from previous page visit

	//END PAGE LOAD

	function _updateView () {
		$('.js-group').removeClass('hide'); //reset all hidden elements
		$('.js-group').removeClass('selected'); //reset all hidden elements
		$('.config-tile').addClass('unselected'); //reset all hidden elements

		$('.cart-text').text((w.zipCode.indexOf("true") >= 0) ? 'Continue' : w.schedulerURL ? "See Schedule" : "Add to Cart"); //update text in button on page load

		if (w.total !== undefined) {
			$('.tileTotal').text(w.total);
			$('.totalText').text("Total");
		}

		if (w.selectedTiles.length > 0) {

			$(w.groupList).each(function (i, g) { //run through stored list of groups that have a selected class
				$('.' + g).addClass('hide'); //hide other items in selected group
			});
			$(w.selectedTiles).each(function (i, c) { //run through stored list of selected classes
				$('#' + c).removeClass('hide unselected').addClass('selected'); //add invoice style to selected class
				$('#' + c + '.pre-selected-tile').addClass('hide'); //add invoice style to selected class
			});

			if (w.groupList.indexOf('subprod') + 1) {
				$('.addToCart').removeClass('disabled');
			} else {
				$('.addToCart').addClass('disabled'); //disable button if no subProduct is selected
			}

		} else {
			$('.addToCart').addClass('disabled'); //disable button when no tiles are selected
		}

		$('.js-hide-all').removeClass('js-hide-all'); //remove hide class afer logic is finished

	}

	function _updateData (classId, add, scheduler, prodId, group, value, requiredZipCode) {
		value = add ? parseInt(value) : (parseInt(value) * -1); // negative value when item is unselected.
		w.total = w.total ? w.total + value : value; //  +/- value of selected item to total.

		if (add === true) {
			// If we are adding selected item
			w.selectedTiles.push(classId);  //add selected classID to list
			if (!scheduler || group !== 'subprod') {
				w.addToCartList.push(classId); //add selected related product
			}
			w.zipCode.push(requiredZipCode); //check api for zip code required field
			w.productId = (scheduler && group === 'subprod') ? prodId : w.productId;  //add selected subproduct
			w.schedulerURL = scheduler ? scheduler : w.schedulerURL;   //update scheduler URL
			w.groupList.push(group);

		} else {
			//if we are removing selected item
			var s = w.selectedTiles.indexOf(classId); //search for classId in array
			if (s !== -1) {
				w.selectedTiles.splice(s, 1); // delete classId from array
			}
			var c = w.addToCartList.indexOf(classId); //search for classId in array
			if (c !== -1) {
				w.addToCartList.splice(c, 1); // delete classId from array
			}
			var g = w.groupList.indexOf(group); //search for classId in array
			if (g !== -1) {
				w.groupList.splice(g, 1); // delete group from array
			}
			w.productId = (scheduler && group === 'subprod') ? '' : w.productId;
			w.schedulerURL = (scheduler && group === 'subprod') ? '' : w.schedulerURL;   //update scheduler URL
		}
		sessionStorage.setItem(docId, JSON.stringify(w)); //update total in Session Storage
	}

	function _clickHandler (thisTile, add) {

		var value = thisTile.attr('config-tile-value'),
			classId = thisTile.attr('config-tile-classId'),
			group = thisTile.attr('config-tile-group'),
			scheduler = thisTile.attr('config-schedule'),
			prodId = thisTile.attr('config-prodId'),
			requiredZipCode = thisTile.attr('config-requiredZipCode');

		_updateData(classId, add, scheduler, prodId, group, value, requiredZipCode);
		_updateView();
	}

	//prevent affirm modal click event from adding product to the cart on .js-config-tile click event
	$('.config-tile-affirm-msg').click(function (e) {
		e.stopPropagation();
	  });
	
	//click on a tile to add to cart
	$('.js-config-tile').on('click', '.unselected', function (e) {


		if ($(this).hasClass('upgrade')) {
			_clickHandler($('.pre-selected-tile'), false);   //remove hidden item from cart
			_clickHandler($(this), true); // add upgrade
		} else if ($(this).hasClass('pre-selected-tile')) {
			//do nothing - .change button will handle
		} else {
			_clickHandler($(this), true);
		}
	});


	//click to remove from cart
	$('.js-config-tile').on('click', '.change', function (e) {
		var thisTile = $(this).parent().parent().parent(); // get tile id

		if ($(this).hasClass('downgrade')) {
			_clickHandler($('.upgrade'), false); //remove upgrade from cart
			_clickHandler($('.pre-selected-tile'), true);  //add pre-selected-tile back into cart
		} else {
			_clickHandler(thisTile, false);
		}
	});

	$('.product-config').on('click', '.addToCart', function (e) { //click on enabled button => get URL, place sessionStorage, load next page
		e.preventDefault();
		if (w.schedulerURL) {
			sessionStorage.setItem('addOn_' + w.productId, w.addToCartList); //drop productId in Session Storage for Scheduler to pick up AddOn classIds list
		}

		var url = w.schedulerURL ? w.schedulerURL : $('#addToCart').attr('data-href') + '?classids=' + w.addToCartList; // If there is no scheduler URL, go to cart
		window.location.href = url;
	});
}



//////////////////
// WEBPACK FOOTER
// ./public/js/product-configuration.js
// module id = 83
// module chunks = 0